<template>
  <div class="form-block"  :class="{'form-block--warning': validationError}">
    <div class="form-block-inner">
      <label>{{field.name}}</label>
      <textarea v-model="value" @keyup="changed" :placeholder="field.placeholder"></textarea>
    </div>
    <div class="form-error" v-if="validationError">
      <i class="icon-error"></i> {{field.name}} is required
    </div>
  </div>
</template>

<script>
export default {
  name: "TextAreaField",
  props:['field', 'validationError'],
  data() {
    return {
      value: ''
    }
  },
  methods: {
    changed() {
      this.$emit('changed',{
        idContentField: this.field.idContentField,
        type: this.field.fieldType,
        files:[],
        multiple: this.field.isMultiline,
        "value": this.value,
        "values":[]
      });
    }
  }
}
</script>

<style scoped>

</style>
